import React, { Component } from "react";
import userprofile from "views/profile/img/user.png";
import { Plus } from "react-feather";
import Tabs from "views/profile/components/Tabs";
import Token from "api/Auth/auth";
import store from "store.js";
import { setMgToken, setHcToken } from "store/Auth";
import { connect } from "react-redux";
import {
  getSingleApplicantInfoAction,
  getUserSingleUserJourneyAction,
  geResumeHC,
  upploadDocument,
  upploadProfilePhotoMG,
} from "../../store/Profile";
import { getBasicAction } from "../../store/userWalkthrough";
import user1 from "views/home/img/map/us1.png";
import FileBase64 from "react-file-base64";
import { setLoader } from "store/Auth";
class Profile extends Component {
  async componentDidMount() {
    try {
    //     let HcToken = await Token.getToken();
    // store.dispatch(setHcToken(HcToken));
    // let MgToken = await Token.getTokenMagitt();
    // store.dispatch(setMgToken(MgToken))

    this.props.setLoader(true);
    if (this.props.Auth.MGID) {
      let payload = {
        HcId: this.props.Auth.HCID ? this.props.Auth.HCID : null,
        MgId: this.props.Auth.MGID,
      };
      let responseSingleApplicantInfo =
        await this.props.getSingleApplicantInfoAction(payload);
    } else {
      alert("Invalid User relogin");
    }

    if (this.props.Auth.HCID) {
      let ResumeResponse = await this.props.geResumeHC(this.props.Auth.HCID);
      let BasicResponse = await this.props.getBasicAction(this.props.Auth.HCID);
    }
    let payloadUser = {
      HcId: this.props.Auth.HCID ? this.props.Auth.HCID : null,
    };
    let res = await this.props.getUserSingleUserJourneyAction(payloadUser);
    this.props.setLoader(false);
  } catch (error) {
    this.props.setLoader(false);
  }
  }
  // async uplodProfilePhoto(){

  // let obj={
  //   CandidateNo: this.props.HCUSERID,
  //   DocumentID: 18,
  //   FileData:"",
  //   FileName: "sample.pdf",
  //   Notes: "By Applicant through DocumentPOrtal",
  //   UserID: 0
  // }

  // let response=await this.props.upploadDocument(obj);
  // }
  async uplodProfilePhoto(files) {
    var inputData = {
      profilePic: files.base64,
      userId: this.props.MGUSERID,
    };
    let obj = {
      CandidateNo: this.props.HCUSERID,
      DocumentID: 18,
      FileData: files.base64.split(",")[1],
      FileName: files.name,
      Notes: "By Applicant through NewCareers",
      UserID: 0,
    };
    let response = await this.props.upploadDocument(obj);
    if (response.ResponseCode == 100) {
      let responseMG = await this.props.upploadProfilePhotoMG(inputData);
      let payload = {
        HcId: this.props.Auth.HCID ? this.props.Auth.HCID : null,
        MgId: this.props.Auth.MGID,
      };
      let responseSingleApplicantInfo =
        await this.props.getSingleApplicantInfoAction(payload);
      alert(response.ResponseMessage);
    } else {
      alert(response.ResponseMessage);
    }
  }
  addDefaultSrc(ev) {
    ev.target.src = user1;
  }
  render() {
    return (
      <div className="mt-80px lg:pt-3 md:pt-3 pt-6">
        <div className="bg053C6D h-80px lg:block md:block hidden"></div>
        <div className="container m-auto">
          <div className="  lg:-mt-12 md:-mt-12	relative">
            <div className="lg:flex md:flex flex lg:justify-start justify-center md:justify-start lg:w-1/6 md:w-1/6 w-full">
              <div className="text-center">
                <div className="relative">
                  <div>
                    <img
                      onError={this.addDefaultSrc}
                      src={
                        this.props.Profile
                          ? this.props.Profile.Data
                            ? this.props.Profile.Data.userProfiledata
                              ? process.env.REACT_APP_IMAGE_BASE_MG +
                                "/" +
                                this.props.Profile.Data.userProfiledata
                                  .u_profilePic
                              : ""
                            : ""
                          : ""
                      }
                      alt="profile"
                      className="h-70px w-70px m-auto rounded-full cursor-pointer"
                    />
                  </div>

                  <div className="bg-white p-6px rounded-full absolute inside-plux-p drop-shadow">
                    <p className="textE77817 fszie16 font-semibold uploade-hidden-v cursor-pointer">
                      <FileBase64
                        accept=".docx,.pdf"
                        multiple={false}
                        onDone={this.uplodProfilePhoto.bind(this)}
                      >
                        Upload Resume
                      </FileBase64>
                      <Plus
                        width="18px"
                        height="18px"
                        className="text-danger cursor-pointer "
                      />
                    </p>

                    {/* <FileBase64
                    accept=".docx,.pdf"
                    multiple={false}
                    onDone={this.uplodProfilePhoto.bind(this)}
                  >
                  
                     Upload Resume
                  </FileBase64> */}
                  </div>
                </div>
                <div className="mt-2">
                  <h1 className="font-bold fsize16">
                    {this.props.Profile &&
                    this.props.Profile.Data &&
                    this.props.Profile.Data.userProfiledata
                      ? this.props.Profile.Data.userProfiledata.u_name
                      : ""}
                  </h1>
                  <p className="fsize12 text575757 pt-1">
                    <span className="textE77817 fsize14 mr-1  font-semibold">
                      30%
                    </span>
                    Profile complete
                  </p>
                </div>
              </div>
            </div>

            <Tabs />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
    HCUSERID: state.Auth.user.HCID,
    MGUSERID: state.Auth.user.MGID,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSingleApplicantInfoAction: async (payload) => {
      await dispatch(getSingleApplicantInfoAction(payload));
    },
    getBasicAction: async (payload) => await dispatch(getBasicAction(payload)),
    getUserSingleUserJourneyAction: async (payload) => {
      await dispatch(getUserSingleUserJourneyAction(payload));
    },
    geResumeHC: async (payload) => await dispatch(geResumeHC(payload)),
    upploadDocument: async (payload) =>
      await dispatch(upploadDocument(payload)),
    upploadProfilePhotoMG: async (payload) =>
      await dispatch(upploadProfilePhotoMG(payload)),
      setLoader:async (flag) => await dispatch(setLoader(flag)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
